import React, {Component} from 'react'
import SystemLabelMasterCollection from 'collections/system_label_master_collection'

class SelectPowerGate extends Component {

  handleChange = (e) => {
    this.props.actions.changeSelectPowerGate({
      selectPowerGate: e.target.value,
    })
  }

  render() {
    const {  payload } = this.props.systemLabelMastersApi
    if (!payload) {return null}
    const systemLabelMasterCollection = new SystemLabelMasterCollection(payload)
    const {selectPowerGate} = this.props
    return <div className='searchArea__item'>
      <h3 className='searchArea__title'>{TRUCKERS.LANG.ITEM.POWER_GATE}</h3>
      <p className='selectWrap searchArea__item__inner'>
        <select
          className="select"
          value={selectPowerGate}
          onChange={this.handleChange}
        >
          <option value="">{TRUCKERS.LANG.ITEM.LIST_SEARCH.ALL}</option>
          {
            systemLabelMasterCollection.getValueList('item','select_power_gate').map(i => {
              return <option key={i.get('label_key')} value={i.get('label_key')}>{i.getValueI18n()}</option>
            })
          }
        </select>
      </p>
    </div>
  }
}
export default SelectPowerGate
